import Myapplications from "../../../jsx/components/Dashboard/MyApplications/myapplications";

const MyApplicationWrapper = () => {
  return <Myapplications />;
};

export default constore(MyApplicationWrapper);
